import React, { useState, useEffect } from 'react'
import { NavLink, useParams, useHistory } from 'react-router-dom'
import useBlockHistory from '../hooks/useBlockHistory'
import ReservationContent from '../components/ReservationContent'

// Objet contenant les données initiales au chargement de la réservation
export default function Reservation() {
  const { id_location, id_task } = useParams()
  const history = useHistory()

  const [title, setTitle] = useState("Chargement des données...")
  const [closedTask, setClosedTask] = useState()
  const {hasChanges, setHasChanges, gotoUrl, setGotoUrl, saveBeforeContinue, continueWithoutSaving} = useBlockHistory()

  // Nettoie les classes du planning
  document.getElementsByTagName("body")[0].classList.remove("popin-tasks-active")

  return (
    <main className={`reservation`}>
      <div className="header">
        <h1>{title}</h1>
      </div>

      <ReservationContent
        id_location={id_location}
        id_task={id_task}
        setTitle={setTitle}
        history={history}
        gotoUrl={gotoUrl}
        setGotoUrl={setGotoUrl}
        hasChanges={hasChanges}
        saveBeforeContinue={saveBeforeContinue}
        continueWithoutSaving={continueWithoutSaving}
        setHasChanges={setHasChanges} />
    </main>
  )
}
